// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "note-3OzU8";
var _3 = "info-1GzRZ";
var _4 = "timelimit-3Lmid";
var _5 = "restriction-3OSxC";
export { _1 as "__esModule", _2 as "note", _3 as "info", _4 as "timelimit", _5 as "restriction" }
export default { "__esModule": _1, "note": _2, "info": _3, "timelimit": _4, "restriction": _5 }
